import { createFileRoute } from '@tanstack/react-router';
import { Option, Schema } from 'effect';
import {
  currentReportYear,
  FIRST_REPORT_YEAR,
} from '../../../regulatory-reports/calendar/dates.ts';
import { DirectorReportPage } from '../../../regulatory-reports/director-report-page.tsx';
import { InvalidLinkPage } from '../../search/invalid-link-page.tsx';

// `?ano=` names a report year the screen offers, from the first one to the current one. The router
// already reads `?ano=2025` as the number 2025 (TanStack's default search parsing), so the key
// decodes as an integer, the same way /receptora's `page` does.
const ReportYear = Schema.Int.check(
  Schema.isGreaterThanOrEqualTo(FIRST_REPORT_YEAR),
  Schema.makeFilter((year: number) => year <= currentReportYear(new Date()), {
    expected: 'a report year up to the current one',
  }),
);

const DirectorReportSearch = Schema.Struct({ ano: Schema.optionalKey(ReportYear) });
const encodeUrl = Schema.encodeSync(
  Schema.Struct({ ano: Schema.OptionFromOptionalKey(ReportYear) }),
);

// Declared inline: the route plugin splits `component` and `errorComponent` into lazy bindings it
// declares after the options. The URL tests mount `Route.options` in a memory router.
export const Route = createFileRoute('/relatorio-diretor/')({
  validateSearch: Schema.toStandardSchemaV1(DirectorReportSearch),
  component: DirectorReportRoute,
  errorComponent: InvalidLinkPage,
});

// The year is a filter of the same report: it replaces the history entry instead of adding one.
function DirectorReportRoute(): JSX.Element {
  const navigate = Route.useNavigate();
  return (
    <DirectorReportPage
      year={Option.fromUndefinedOr(Route.useSearch().ano)}
      onYear={(next) => {
        void navigate({ search: encodeUrl({ ano: next }), replace: true });
      }}
    />
  );
}
